import { i18nConfig } from './configs';

export function removeLocaleFromPath(pathname: string): string {
  // Remove the locale prefix if it exists
  const pathWithoutLocale = i18nConfig.locales.reduce((path, locale) => {
    return path.replace(`/${locale.toLowerCase()}`, '');
  }, pathname);

  // Ensure the path starts with a slash
  return pathWithoutLocale.startsWith('/')
    ? pathWithoutLocale
    : `/${pathWithoutLocale}`;
}

export function removeDefaultLocaleFromPath(pathname: string): string {
  // Remove the default locale prefix if it exists
  const pathWithoutDefaultLocale = pathname.replace(
    `/${i18nConfig.defaultLocale.toLowerCase()}`,
    ''
  );

  // Ensure the path starts with a slash
  return pathWithoutDefaultLocale.startsWith('/')
    ? pathWithoutDefaultLocale
    : `/${pathWithoutDefaultLocale}`;
}
